import PropTypes from 'prop-types';
import React from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import CollapsibleSection from 'modules/Common/components/CollapsibleSection';
import { racingProfileLink } from 'modules/HorseRacing/utils';
import SubscriptionContainer from 'modules/Common/containers/Subscriptions/SubscriptionContainer';
import MyStableLink from 'modules/Common/containers/Subscriptions/MyStableLink';

require('./MyStableSearchResults.scss');

function MyStableSearchResults(props) {
  return (
    <section className="my-stable-search-container">
      <MetaDataWrapper title="Search"/>
      <h3 className="section-title">
        { props.myStableHorseResults.searchText ?
          `Search Results for "${props.myStableHorseResults.searchText}"`
        :
          'Enter search criteria'
        }
      </h3>

      <SearchResultsTable
        keyName="Horse"
        linkType="horse"
        results={props.myStableHorseResults.horseSearchResults}
        loading={!!props.myStableHorseResults.loading}
        searchText={props.myStableHorseResults.searchText}
        resultMap={horse => ({ type: 'HORSE', id: horse.horse_reference.id, text: horse.name })}
      />

      <SearchResultsTable
        keyName="Jockey"
        linkType="jockey"
        results={props.myStableJockeyResults.jockeySearchResults}
        loading={!!props.myStableJockeyResults.loading}
        searchText={props.myStableHorseResults.searchText}
        resultMap={jockey => ({ type: 'JOCKEY', id: jockey.person_reference.id, text: jockey.name })}
      />

      <SearchResultsTable
        keyName="Trainer"
        linkType="trainer"
        results={props.myStableTrainerResults.trainerSearchResults}
        loading={!!props.myStableTrainerResults.loading}
        searchText={props.myStableHorseResults.searchText}
        resultMap={trainer => ({ type: 'TRAINER', id: trainer.business_reference.id, text: trainer.name })}
      />
    </section>
  );
}

MyStableSearchResults.propTypes = {
  myStableHorseResults: PropTypes.shape({
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    horseSearchResults: PropTypes.array.isRequired,
    searchText: PropTypes.string
  }),
  myStableJockeyResults: PropTypes.shape({
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    jockeySearchResults: PropTypes.array.isRequired
  }),
  myStableTrainerResults: PropTypes.shape({
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    trainerSearchResults: PropTypes.array.isRequired
  })
};

export default connect(
  state => {
    return {
      myStableHorseResults: state.horseRacing.myStableHorseSearch,
      myStableJockeyResults: state.horseRacing.myStableJockeySearch,
      myStableTrainerResults: state.horseRacing.myStableTrainerSearch
    };
  }
)(MyStableSearchResults);


function SearchResultsTable({keyName, linkType, results = [], loading, searchText, resultMap}) {

  const mappedResults = results.map(result => resultMap(result));

  return (
    <div className="my-stable-search-results">
      <CollapsibleSection title={`${keyName}s (${loading ? 'loading results...' : `${results.length} result/s`})`} collapsed={!(results.length > 0)}>
        { results.length > 0 ?
          <div className="my-stable-search-table-container">
            { loading && <div className="loading-overlay"></div>}
            <table className="my-stable-search-table">
              <tbody>
                {
                  mappedResults.map(({ type, id, text }) => (
                    <tr key={id} className="my-stable-search-row">
                      <td className="my-stable-search-name">
                        <Link to={racingProfileLink(linkType, id)}>{text}</Link>
                      </td>
                      <td className="my-stable-search-add">
                        <SubscriptionContainer
                          addSubscriptions={ [{ type, id, text }] }
                          icon={ <MyStableLink /> }
                        />
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        :
          searchText ?
            <div className="my-stable-search-no-results">{`Sorry, no ${keyName} profiles found for `}<span>{`'${searchText}'`}</span></div>
          :
            <div className="my-stable-search-no-results">Enter search criteria</div>
        }
      </CollapsibleSection>
    </div>
  );
}

SearchResultsTable.propTypes = {
  keyName: PropTypes.string.isRequired,
  linkType: PropTypes.string.isRequired,
  results: PropTypes.array,
  loading: PropTypes.bool,
  searchText: PropTypes.string,
  resultMap: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/MyStableSearchResults.js